var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundVacancy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1122,
    height: 862,
    viewBox: "0 0 1122 862",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_299_3139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M967.9 189.101L978.328 136.243L966.859 148.929L944.776 214.093L934.348 266.951L945.817 254.265L967.9 189.101Z",
    stroke: "url(#paint0_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.522 189.034L980.326 132.668L968.145 145.238L943.981 214.256L932.177 270.623L944.537 257.971L968.522 189.034Z",
    stroke: "url(#paint1_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.143 188.963L982.408 128.822L969.514 141.273L943.361 214.327L930.096 274.468L942.99 262.017L969.143 188.963Z",
    stroke: "url(#paint2_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.852 189.075L984.749 124.608L971.057 137.211L942.646 214.199L927.927 278.584L941.441 266.063L969.852 189.075Z",
    stroke: "url(#paint3_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.658 189.391L987.183 120.565L972.688 132.86L941.846 213.9L925.321 282.727L939.816 270.431L970.658 189.391Z",
    stroke: "url(#paint4_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.64 189.622L989.701 116.251L974.673 128.344L941.043 213.589L922.804 287.041L938.01 274.866L971.64 189.622Z",
    stroke: "url(#paint5_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.44 189.928L992.658 111.91L976.56 123.587L940.242 213.282L919.846 291.382L935.945 279.705L972.44 189.928Z",
    stroke: "url(#paint6_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.153 190.506L995.7 107.299L978.708 118.473L939.347 212.771L916.978 295.895L933.969 284.721L973.153 190.506Z",
    stroke: "url(#paint7_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.047 191.017L998.743 102.687L981.036 113.274L938.456 212.274L913.761 300.604L931.645 289.935L974.047 191.017Z",
    stroke: "url(#paint8_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.032 191.715L1002.14 97.8779L983.446 107.768L937.651 211.495L910.37 305.415L929.06 295.525L975.032 191.715Z",
    stroke: "url(#paint9_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.928 192.689L1005.79 93.1604L986.206 102.075L936.576 210.601L906.71 310.13L926.297 301.215L975.928 192.689Z",
    stroke: "url(#paint10_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.832 193.677L1009.55 88.28L989.062 96.2075L935.673 209.615L902.952 315.012L923.443 307.084L976.832 193.677Z",
    stroke: "url(#paint11_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.919 195.05L1013.76 83.4155L992.178 89.9695L934.586 208.241L898.749 319.875L920.504 313.238L977.919 195.05Z",
    stroke: "url(#paint12_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.826 196.502L1018.13 78.4562L995.468 83.6349L933.675 206.776L894.546 324.739L917.033 319.643L978.826 196.502Z",
    stroke: "url(#paint13_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.829 198.162L1022.6 73.7094L999.024 76.959L932.675 205.13L889.991 329.776L913.48 326.333L979.829 198.162Z",
    stroke: "url(#paint14_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.01 200.195L1027.6 68.6704L1002.93 70.0721L931.665 202.999L885.076 334.523L909.748 333.122L981.01 200.195Z",
    stroke: "url(#paint15_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.019 202.329L1032.69 63.8259L1007.01 63.101L930.662 200.879L879.814 339.464L905.493 340.189L982.019 202.329Z",
    stroke: "url(#paint16_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.033 204.93L1037.96 58.9081L1011.36 55.7772L929.472 198.364L874.55 344.385L901.15 347.516L983.033 204.93Z",
    stroke: "url(#paint17_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.141 207.715L1043.76 54.1811L1016.05 48.254L928.548 195.473L868.754 349.09L896.55 355.21L984.141 207.715Z",
    stroke: "url(#paint18_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.977 210.878L1049.82 49.5749L1021 40.3773L927.523 192.4L862.858 353.62L891.496 362.901L984.977 210.878Z",
    stroke: "url(#paint19_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.093 214.625L1056.24 45.2415L1026.4 32.4903L926.407 188.652L856.436 357.953L886.098 370.787L986.093 214.625Z",
    stroke: "url(#paint20_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.031 218.459L1062.93 41.0266L1032.06 24.2466L925.468 184.816L849.745 362.165L880.615 378.945L987.031 218.459Z",
    stroke: "url(#paint21_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.072 222.973L1069.81 37.2067L1038.08 15.8377L924.433 180.318L842.698 366.085L874.606 387.37L988.072 222.973Z",
    stroke: "url(#paint22_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989.113 227.961L1077.3 33.7594L1044.53 7.40209L923.391 175.33L835.204 369.531L868.154 395.805L989.113 227.961Z",
    stroke: "url(#paint23_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.068 233.229L1085.15 30.6104L1051.33 -1.2153L922.61 169.966L827.528 372.584L861.349 404.41L990.068 233.229Z",
    stroke: "url(#paint24_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.946 239.273L1093.18 27.8381L1058.57 -9.83104L921.735 163.935L819.324 375.453L853.93 413.123L990.946 239.273Z",
    stroke: "url(#paint25_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.742 246.064L1101.75 25.754L1066.17 -18.6297L920.758 157.213L810.929 377.439L846.333 421.907L991.742 246.064Z",
    stroke: "url(#paint26_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.368 253.435L1110.59 24.2451L1074.38 -27.5099L920.132 149.841L802.09 378.948L838.12 430.786L992.368 253.435Z",
    stroke: "url(#paint27_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.094 261.502L1119.79 23.5109L1082.86 -36.3027L919.411 141.791L792.718 379.783L829.647 439.596L993.094 261.502Z",
    stroke: "url(#paint28_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.736 270.337L1129.34 23.5298L1092.04 -45.008L918.945 132.87L783.161 379.761L820.465 448.299L993.736 270.337Z",
    stroke: "url(#paint29_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.122 280.034L1139.44 24.7185L1101.66 -53.7119L918.558 123.173L773.061 378.572L810.843 457.002L994.122 280.034Z",
    stroke: "url(#paint30_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.239 290.685L1149.86 26.5135L1111.78 -62.4844L918.266 112.605L762.825 376.692L800.724 465.774L994.239 290.685Z",
    stroke: "url(#paint31_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.357 302.382L1160.52 29.7709L1122.5 -71.0145L918.144 100.895L751.979 373.506L790.174 474.207L994.357 302.382Z",
    stroke: "url(#paint32_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.31 315.213L1171.63 34.0262L1133.57 -79.3005L918.194 88.0804L741.051 369.182L778.93 482.594L994.31 315.213Z",
    stroke: "url(#paint33_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.914 329.268L1183.09 40.0122L1145.43 -87.3697L918.591 74.0243L729.592 363.196L767.074 490.662L993.914 329.268Z",
    stroke: "url(#paint34_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.347 344.481L1194.9 47.7694L1157.72 -95.0235L919.158 58.81L717.601 355.522L754.784 498.315L993.347 344.481Z",
    stroke: "url(#paint35_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.52 361.178L1207.06 57.3015L1170.71 -102.187L919.985 42.1151L705.618 345.906L741.798 505.48L992.52 361.178Z",
    stroke: "url(#paint36_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.43 379.395L1219.57 69.1135L1184.3 -108.592L921.075 23.8983L693.116 334.094L728.206 511.885L991.43 379.395Z",
    stroke: "url(#paint37_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M990.207 397.941L1232.59 84.0446L1198.72 -112.293L922.474 5.26625L679.917 319.248L713.783 515.585L990.207 397.941Z",
    stroke: "url(#paint38_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.507 417.797L1246.2 101.507L1213.86 -114.6L923.997 -14.5044L666.481 301.699L698.648 517.893L988.507 417.797Z",
    stroke: "url(#paint39_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.384 438.94L1259.88 121.725L1229.83 -115.618L926.118 -35.6611L652.623 281.554L682.844 518.812L986.384 438.94Z",
    stroke: "url(#paint40_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.022 461.739L1274.17 144.917L1246.49 -115.225L928.656 -58.5458L638.505 258.276L666.188 518.418L984.022 461.739Z",
    stroke: "url(#paint41_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.975 486.163L1288.46 171.106L1263.65 -113.37L931.529 -82.8732L624.22 232.1L648.855 516.661L980.975 486.163Z",
    stroke: "url(#paint42_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.504 512.285L1303.01 200.829L1281.85 -109.86L935.172 -109.093L609.662 202.363L630.828 513.052L977.504 512.285Z",
    stroke: "url(#paint43_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M973.263 540.281L1317.76 234.36L1300.66 -104.233L939.243 -136.988L594.921 168.85L611.843 507.526L973.263 540.281Z",
    stroke: "url(#paint44_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.506 570.19L1332.43 271.982L1320.27 -96.6113L943.994 -166.914L580.065 131.293L592.409 499.803L968.506 570.19Z",
    stroke: "url(#paint45_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.063 602.117L1347.41 313.991L1340.51 -86.4381L949.442 -198.824L565.099 89.3015L571.997 489.73L963.063 602.117Z",
    stroke: "url(#paint46_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.744 636.101L1362.23 360.754L1361.56 -73.8533L955.76 -232.811L550.453 42.4527L550.948 477.143L956.744 636.101Z",
    stroke: "url(#paint47_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.731 672.473L1376.83 412.488L1383.35 -58.1045L962.772 -269.181L535.673 -9.19716L529.149 461.396L949.731 672.473Z",
    stroke: "url(#paint48_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.655 710.944L1391.3 469.808L1405.81 -39.4491L970.848 -307.653L521.383 -66.5989L506.697 442.741L941.655 710.944Z",
    stroke: "url(#paint49_linear_299_3139)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M932.515 751.921L1405.29 533.26L1429.12 -17.0555L979.989 -348.629L507.211 -129.968L483.385 420.347L932.515 751.921Z",
    stroke: "url(#paint50_linear_299_3139)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_299_3139",
    x1: 978.328,
    y1: 136.243,
    x2: 1011.24,
    y2: 243.318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_299_3139",
    x1: 980.326,
    y1: 132.668,
    x2: 1015.22,
    y2: 244.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_299_3139",
    x1: 982.408,
    y1: 128.822,
    x2: 1019.37,
    y2: 246.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_299_3139",
    x1: 984.749,
    y1: 124.608,
    x2: 1023.95,
    y2: 248.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_299_3139",
    x1: 987.183,
    y1: 120.565,
    x2: 1028.61,
    y2: 249.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_299_3139",
    x1: 989.701,
    y1: 116.251,
    x2: 1033.43,
    y2: 251.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_299_3139",
    x1: 992.658,
    y1: 111.91,
    x2: 1038.75,
    y2: 252.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_299_3139",
    x1: 995.7,
    y1: 107.299,
    x2: 1044.23,
    y2: 253.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_299_3139",
    x1: 998.743,
    y1: 102.687,
    x2: 1049.77,
    y2: 255.064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_299_3139",
    x1: 1002.14,
    y1: 97.8779,
    x2: 1055.72,
    y2: 256.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_299_3139",
    x1: 1005.7,
    y1: 92.9677,
    x2: 1061.88,
    y2: 257.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_299_3139",
    x1: 1008.91,
    y1: 86.93,
    x2: 1068.23,
    y2: 259.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_299_3139",
    x1: 1012.38,
    y1: 80.5211,
    x2: 1075.02,
    y2: 262.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_299_3139",
    x1: 1016.02,
    y1: 74.0156,
    x2: 1082.02,
    y2: 265.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_299_3139",
    x1: 1019.57,
    y1: 67.3351,
    x2: 1089.06,
    y2: 268.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_299_3139",
    x1: 1023.65,
    y1: 60.3591,
    x2: 1096.74,
    y2: 270.641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_299_3139",
    x1: 1027.73,
    y1: 53.3813,
    x2: 1104.46,
    y2: 273.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_299_3139",
    x1: 1031.89,
    y1: 46.1354,
    x2: 1112.38,
    y2: 276.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_299_3139",
    x1: 1036.41,
    y1: 38.6893,
    x2: 1120.79,
    y2: 278.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_299_3139",
    x1: 1041,
    y1: 30.9733,
    x2: 1129.3,
    y2: 281.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_299_3139",
    x1: 1045.86,
    y1: 23.3291,
    x2: 1138.11,
    y2: 283.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_299_3139",
    x1: 1050.81,
    y1: 15.4127,
    x2: 1147.14,
    y2: 286.358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_299_3139",
    x1: 1055.76,
    y1: 7.49841,
    x2: 1156.19,
    y2: 288.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_299_3139",
    x1: 1061.15,
    y1: -0.443237,
    x2: 1165.64,
    y2: 291.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_299_3139",
    x1: 1066.71,
    y1: -8.48218,
    x2: 1175.29,
    y2: 293.116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_299_3139",
    x1: 1072.36,
    y1: -16.3521,
    x2: 1184.97,
    y2: 294.885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_299_3139",
    x1: 1078.18,
    y1: -24.3196,
    x2: 1194.81,
    y2: 296.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_299_3139",
    x1: 1084.09,
    y1: -32.1162,
    x2: 1204.65,
    y2: 297.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_299_3139",
    x1: 1090.1,
    y1: -39.7399,
    x2: 1214.49,
    y2: 299.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_299_3139",
    x1: 1096.28,
    y1: -47.0223,
    x2: 1224.27,
    y2: 299.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_299_3139",
    x1: 1102.54,
    y1: -54.132,
    x2: 1234.02,
    y2: 299.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_299_3139",
    x1: 1111.78,
    y1: -62.4844,
    x2: 1247.15,
    y2: 298.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_299_3139",
    x1: 1122.5,
    y1: -71.0145,
    x2: 1261.61,
    y2: 295.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_299_3139",
    x1: 1133.57,
    y1: -79.3005,
    x2: 1276.18,
    y2: 291.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_299_3139",
    x1: 1145.43,
    y1: -87.3697,
    x2: 1291.16,
    y2: 286.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_299_3139",
    x1: 1157.72,
    y1: -95.0235,
    x2: 1306.12,
    y2: 280.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_299_3139",
    x1: 1170.71,
    y1: -102.187,
    x2: 1321.21,
    y2: 273.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_299_3139",
    x1: 1184.3,
    y1: -108.592,
    x2: 1336.14,
    y2: 264.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_299_3139",
    x1: 1192.36,
    y1: -126.257,
    x2: 1353.87,
    y2: 273.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_299_3139",
    x1: 1198.65,
    y1: -147.8,
    x2: 1372.55,
    y2: 288.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_299_3139",
    x1: 1204.67,
    y1: -170.299,
    x2: 1391.41,
    y2: 304.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_299_3139",
    x1: 1210.07,
    y1: -194.002,
    x2: 1410.31,
    y2: 323.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_299_3139",
    x1: 1214.76,
    y1: -218.635,
    x2: 1428.95,
    y2: 343.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_299_3139",
    x1: 1218.99,
    y1: -244.569,
    x2: 1447.66,
    y2: 364.862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_299_3139",
    x1: 1222.25,
    y1: -271.505,
    x2: 1465.82,
    y2: 388.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_299_3139",
    x1: 1224.61,
    y1: -299.719,
    x2: 1483.51,
    y2: 414.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_299_3139",
    x1: 1225.73,
    y1: -329.007,
    x2: 1500.28,
    y2: 442.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_299_3139",
    x1: 1225.78,
    y1: -359.472,
    x2: 1516.17,
    y2: 473.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_299_3139",
    x1: 1224.22,
    y1: -391.256,
    x2: 1530.65,
    y2: 507.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_299_3139",
    x1: 1221.24,
    y1: -424.017,
    x2: 1543.56,
    y2: 543.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_299_3139",
    x1: 1216.47,
    y1: -458,
    x2: 1554.5,
    y2: 582.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4ABDCC",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#2CEBC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#6B8AD1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8267D5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_299_3139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1734,
    height: 1320,
    fill: "white",
    transform: "translate(0 -458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundVacancy);
export default __webpack_public_path__ + "static/media/background-vacancy.21cb93bfbdebbddeb5d942e19154cc44.svg";
export { ForwardRef as ReactComponent };